import React from 'react';
import { useNavigate as useHistory } from 'react-router-dom';
import moment from 'moment';
import Utils from 'utils';
import { useDispatch } from 'react-redux';
import {
  initialState as Is_newReportCompiler,
  updateFilters,
  updateData,
  updateTextFilters,
  updateTableData
} from '../../redux/reducers/NewReportCompiler.reducer';

function DownloadDocument({
  mainTitle,
  title,
  periodoString,
  descrizione,
  idFunzione,
  metadati,
  pData,
  disabled,
  tabIndex,
  urlPath
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const date = moment();
  const fullDate =
    date.format('DD', { trim: false }) +
    '-' +
    date.format('MM', { trim: false }) +
    '-' +
    date.format('YYYY', { trim: false });
  let startDate = periodoString.substring(
    periodoString.indexOf(':') + 1,
    periodoString.indexOf('-')
  );
  let endDate = Utils.escapeDate(periodoString.substring(periodoString.indexOf('-') + 1));
  endDate = endDate ? endDate : moment().format('DD/MM/YYYY');
  const periodoDate = [startDate, endDate];
  return (
    <div
      className={`download-document ${disabled ? 'disabled-download' : ''}`}
      onClick={() => {
        dispatch(updateTableData(Is_newReportCompiler.tableData));
        dispatch(updateTextFilters(Is_newReportCompiler.textFilters));
        dispatch(updateFilters(Is_newReportCompiler.filters));
        let dtDaUp = moment(pData, 'DD/MM/YYYY').format('YYYY-MM-DD');
        dispatch(
          updateData({ dataDaUp: moment(pData, 'DD/MM/YYYY').format('YYYY-MM-DD'), dataAUp: null })
        );

        history(`/home/${urlPath || 'link'}?id=${idFunzione}&dateFrom=${dtDaUp}`, {
          state: {
            dataDa: pData.replaceAll('/', '-'),
            funzione: idFunzione,
            title,
            mainTitle,
            periodoDate,
            descrizione,
            metadati_val: metadati,
            reportQueryString: `?id=${idFunzione}&dateFrom=${dtDaUp}`,
            showFromDate: pData?.replaceAll('/', '-') !== fullDate,
            isEditable: false,
            fromHome: true,
            homeDataPicker: pData?.replaceAll('/', '-') === fullDate ? 'al' : 'dal'
          }
        });
      }}
      onKeyPress={(event) => {
        if (event.key === 'Enter') {
          dispatch(updateTableData(Is_newReportCompiler.tableData));
          dispatch(updateTextFilters(Is_newReportCompiler.textFilters));
          dispatch(updateFilters(Is_newReportCompiler.filters));
          let dtDaUp = moment(pData, 'DD/MM/YYYY').format('YYYY-MM-DD');
          dispatch(
            updateData({
              dataDaUp: moment(pData, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              dataAUp: null
            })
          );

          history(`/home/${urlPath || 'link'}?id=${idFunzione}&dateFrom=${dtDaUp}`, {
            state: {
              dataDa: pData.replaceAll('/', '-'),
              funzione: idFunzione,
              title,
              mainTitle,
              periodoDate,
              descrizione,
              metadati_val: metadati,
              reportQueryString: `?id=${idFunzione}&dateFrom=${dtDaUp}`,
              showFromDate: pData?.replaceAll('/', '-') !== fullDate,
              isEditable: false,
              fromHome: true,
              homeDataPicker: pData?.replaceAll('/', '-') === fullDate ? 'al' : 'dal'
            }
          });
        }
      }}
      tabIndex={tabIndex}>
      <div>
        <a className="text-left title-mth">{title}</a>
      </div>
      <div className="d-flex flex-wrap justify-content-start mt-auto noWarp">
        <span className="noWarp span">
          {pData?.replaceAll('/', '-') === fullDate ? 'Al' : 'Dal'}:{' '}
        </span>{' '}
        {pData}
      </div>
    </div>
  );
}

export default DownloadDocument;
